<template>
  <div class="content">
    <div class="background-image-search" style="background-image: url(/img/temp/blurred-dark.jpg"></div>
    
      <base-header class="header--recipe pb-6" type="none">
        <b-row align-v="center" class="py-4">
          <b-col xs="12">
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block">
              <RouteBreadCrumb />
            </nav>
          </b-col>
        </b-row>
        <b-row align-v="center" class="py-4">
          <b-col xs="12" lg="6" align="left">
            <h2 class="text-white">Chef {{ chef.fullNameFirstLast }}</h2>
            <img id="chef-pic" v-if="chef.image" :src="chef.image.absoluteUri" />
          </b-col>
        </b-row>
      </base-header>

      <RecipeList :searchUri="'recipes/searchRecipes'" :v="grid" :binder="this.$store.state.recipes.all" :payload="{ chefId: $route.params.id }" />
    </div>

</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import RecipeList from '@/views/Recipe/RecipeList.vue';

export default {
  components: {
    RouteBreadCrumb,
    RecipeList
  },
   computed: {
    chef() {
      return this.$store.state.users.all.results.filter(user => user.id === this.$route.params.id)[0];
    }
  },
  created() {
    const { dispatch } = this.$store;
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
#chef-pic { height: 150px; width: auto; }
</style>
